import { render, staticRenderFns } from "./Friend.vue?vue&type=template&id=626a0846&scoped=true&lang=html&"
import script from "./Friend.vue?vue&type=script&lang=js&"
export * from "./Friend.vue?vue&type=script&lang=js&"
import style0 from "./Friend.vue?vue&type=style&index=0&id=626a0846&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626a0846",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
